<template>
    <v-flex>
        <h1 class="display-3">Actualización de padrón de Arba</h1>

    </v-flex>
</template>

<script>
    export default {
        name: "arba",
        data() {
            return {
                file: ''
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/varios/arba.vue